import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from "../../app/constants"

const paymentPreviewSlice = createSlice({
    name : "paymentPreview",
    initialState : {
        header : "Get ready to pay",
        navigation : {
            next : ROUTE_PATH.CONFIRM_APPLICATION_SUBMISSION,
            nextRenewal : ROUTE_PATH.WELCOME
        }
    },
    reducer : {

    }
})

export default paymentPreviewSlice.reducer
